<template>
  	<div>
		<div class="page-wrapper page-wrapper--padded">
			<div class="main-panel">
				<h1 class="title title--main">{{ $t('news.pageTitle') }}</h1>
				<ul class="article-listing">
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news26.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news26.title')"><span class="lang-warning">{{ $t('news.news26.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news26.date') }} | {{ $t('news.news26.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news26.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news25.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news25.title')"><span class="lang-warning">{{ $t('news.news25.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news25.date') }} | {{ $t('news.news25.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news25.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news24.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news24.title')"><span class="lang-warning">{{ $t('news.news24.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news24.date') }} | {{ $t('news.news24.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news24.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news23.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news23.title')"><span class="lang-warning">{{ $t('news.news23.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news23.date') }} | {{ $t('news.news23.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news23.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news22.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news22.title')"><span class="lang-warning">{{ $t('news.news22.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news22.date') }} | {{ $t('news.news22.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news22.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news21.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news21.title')"><span class="lang-warning">{{ $t('news.news21.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news21.date') }} | {{ $t('news.news21.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news21.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news20.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news20.title')"><span class="lang-warning">{{ $t('news.news20.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news20.date') }} | {{ $t('news.news20.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news20.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news19.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news19.title')"><span class="lang-warning">{{ $t('news.news19.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news19.date') }} | {{ $t('news.news19.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news19.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news18.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news18.title')"><span class="lang-warning">{{ $t('news.news18.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news18.date') }} | {{ $t('news.news18.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news18.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news17.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news17.title')"><span class="lang-warning">{{ $t('news.news17.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news17.date') }} | {{ $t('news.news17.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news17.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<router-link  class="article-listing__link" :to="$locale.toRouteLinkProp('news2')">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news16.title')"><span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news16.date') }} | {{ $t('news.news16.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news16.deck')"></p>
							</div>
						</router-link>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news15.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news15.title')"><span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news15.date') }} | {{ $t('news.news15.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news15.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news14.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news14.title')"><span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news14.date') }} | {{ $t('news.news14.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news14.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news13.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news13.title')"><span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news13.date') }} | {{ $t('news.news13.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news13.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news12.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news12.title')"><span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news12.date') }} | {{ $t('news.news12.source') }}</div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news12.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news11.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing" v-html="$t('news.news11.title')"><span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news11.date') }} | {{ $t('news.news11.source') }} </div>
								</div>
								<p class="article-listing__deck" v-html="$t('news.news11.deck')"></p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<router-link class="article-listing__link" :to="$locale.toRouteLinkProp('blog')">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing">{{ $t('news.news10.title') }} <span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news10.date') }} | {{ $t('news.news10.source') }} | {{ $t('news.news10.type') }}</div>
								</div>
								<p class="article-listing__deck">{{ $t('news.news10.deck') }}</p>
							</div>
						</router-link>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news9.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing">{{ $t('news.news9.title') }} <span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news9.date') }} | {{ $t('news.news9.source') }}</div>
								</div>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news7.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing">{{ $t('news.news7.title') }} <span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news7.date') }} | {{ $t('news.news7.source') }}</div>
								</div>
								<p class="article-listing__deck">{{ $t('news.news7.deck') }}</p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news6.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing">{{ $t('news.news6.title') }} <span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news6.date') }} | {{ $t('news.news6.source') }}</div>
								</div>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<router-link class="article-listing__link" :to="$locale.toRouteLinkProp('news1')">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing">{{ $t('news.news8.title') }} <span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news8.date') }} | {{ $t('news.news8.source') }}</div>
								</div>
								<p class="article-listing__deck">{{ $t('news.news8.deck') }}</p>
							</div>
						</router-link>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news5.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing">{{ $t('news.news5.title') }} <span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news5.date') }} | {{ $t('news.news5.source') }}</div>
								</div>
								<p class="article-listing__deck">{{ $t('news.news5.deck') }}</p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news3.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing">{{ $t('news.news3.title') }} <span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news3.date') }} | {{ $t('news.news3.source') }}</div>
								</div>
								<p class="article-listing__deck">{{ $t('news.news3.deck') }}</p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news2.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing">{{ $t('news.news2.title') }} <span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news2.date') }} | {{ $t('news.news2.source') }}</div>
								</div>
								<p class="article-listing__deck">{{ $t('news.news2.deck') }}</p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news1.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing">{{ $t('news.news1.title') }} <span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news1.date') }} | {{ $t('news.news1.source') }}</div>
								</div>
								<p class="article-listing__deck">{{ $t('news.news1.deck') }}</p>
							</div>
						</a>
					</li>
					<li class="article-listing__item">
						<a class="article-listing__link" :href="$t('news.news4.link')" target="__blank">
							<div class="article-listing__text-content">
								<h2 class="title title--article-listing">{{ $t('news.news4.title') }} <span class="lang-warning">{{ $t('news.news8.langWarning') }}</span></h2>
								<div class="article-listing__details">
									<div class="article-listing__date">{{ $t('news.news4.date') }} | {{ $t('news.news4.source') }}</div>
								</div>
								<p class="article-listing__deck">{{ $t('news.news4.deck') }}</p>
							</div>
						</a>
					</li>
				</ul>
			</div>
			<aside class="side-panel">
				<div class="side-panel__module">
					<h3 class="title title--side-panel">{{ $t('news.aboutTitle') }}</h3>
					<p class="side-panel__text">{{ $t('news.aboutText') }}</p>
				</div>
				<h3 class="title title--side-panel">{{ $t('news.vidModuleTitle') }}</h3>
				<div class="side-panel__module side-panel__module--video">
					<a :href="$t('news.vidLink')" class="videobloc-link" target="__blank">
						<figure class="sidepanel__video-wrap"><img :src="require('@/assets/pages/news/video-still.jpg')" class="sidepanel__video-thumb"/></figure>
						<div class="sidepanel__sidetext">
							<h3 class="title title--video-side-panel">{{ $t('news.vidTitle') }}</h3>
							<p class="side-panel__text side-panel__text--sm">Prospects CRM / Mobile</p>
							<p class="side-panel__text side-panel__text--smb">3:02</p>
						</div>
					</a>
				</div>
				<div class="side-panel__module">
					<h3 class="title title--side-panel">{{ $t('news.socialTitle') }}</h3>
					<ul class="sidepanel__social-list">
						<li class="sidepanel__social-list-item"><a href="https://facebook.com/prospects" target="_blank"><img src="@/assets/facebook-color.svg" alt="Follow-us on Facebook!" style="width: 45px"/></a></li>
						<li class="sidepanel__social-list-item"><a href="https://twitter.com/prspcts" target="_blank"><img src="@/assets/twitter-color.svg" alt="Follow-us on Facebook!" style="width: 45px"/></a></li>
						<li class="sidepanel__social-list-item"><a href="https://www.linkedin.com/company/prospects-software-inc/" target="_blank"><img src="@/assets/linkedin-color.svg" alt="Follow-us on twitter!" style="width: 45px"/></a></li>
						<li class="sidepanel__social-list-item"><a href="https://www.youtube.com/user/Prospectstube" target="_blank"><img src="@/assets/youtube-color.svg" alt="Follow-us on Youtube!" style="width: 45px"/></a></li>
						<li class="sidepanel__social-list-item"><a href="https://www.instagram.com/prospects_software/" target="_blank"><img src="@/assets/instagram-color.svg" alt="Follow-us on Instagram!" style="width: 45px"/></a></li>
					</ul>
				</div>
				<div class="side-panel__module">
					<h3 class="title title--side-panel">{{ $t('news.contactTitle') }}</h3>
					<p class="side-panel__text">Lisa Gaetz<br>{{ $t('news.contactFunction') }}<br><a href="mailto:lisa@prospects.com">lisa@prospects.com</a><br>{{ $t('news.phoneLabel') }} <a href="phone:8887659223">(888) 765-9223 ext. 207</a></p>
				</div>
				<div class="side-panel__module">
					<h3 class="title title--side-panel">Resources - Mobile App</h3>
					<p class="side-panel__text"><a href="http://design.prospects.com/assets/" target="_blank">Logos, videos, flyers, and other marketing resources for MLS-Touch and Prospects Mobile.</a></p>
				</div>
			</aside>
		</div>
  	</div>
</template>


<script>
import Introducer from '@/components/utils/Introducer.vue'

export default {
	components: { Introducer },

	mounted () {
	},

	data () {
		 return {
		 }
	},

	computed: {

	},

	methods: {
	}
};
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Libre+Baskerville:400i&display=swap');

	$quote-font: 'Libre Baskerville', serif;
	$news-font : 'Montserrat', sans-serif;

	//breakpoints
	$screen-sm: 576px;
	$screen-md: 768px;
	$screen-lg:	992px;
	$screen-xl:	1280px;

	//breakpoints mixin

	@mixin media-breakpoint-up($class) {

	  @if $class == sm {
	    @media (min-width: $screen-sm) { @content; }
	  }

	  @else if $class == md {
	    @media (min-width: $screen-md) { @content; }
	  }

	  @else if $class == lg {
	    @media (min-width: $screen-lg) { @content; }
	  }

	   @else if $class == xl {
	    @media (min-width: $screen-xl) { @content; }
	  }

	  @else {
	    @warn "Breakpoint mixin supports: xs, sm, md, lg";
	  }
	}
	//main article font
	@mixin newsFont($colour: false, $size: false, $weight: false,  $lh: false) {
	    font-family: $news-font, Helvetica, Arial, sans-serif;
	    //@if $size { font-size: $size; }
	    @if $colour { color: $colour; }
	    @if $size { font-size: $size; }
	    @if $weight { font-weight: $weight; }
	    @if $lh { line-height: $lh; }
	}

	.page-wrapper--padded {
		display: flex;
		flex-direction: column;
		padding: 40px 0 25px;
		@include media-breakpoint-up(lg) {
			flex-direction: row;
		}
	}
	.main-panel {
		flex-basis: 100%;
		padding-right: 0;
		@include media-breakpoint-up(lg) {
			flex-basis: 70%;
			padding-right: 3em;
		}
	}
	.title {
		margin-bottom: 1em;
	}
	.title--main {
		@include newsFont (#000, 40px, 300, 42px);
	}
	.article-listing {
		list-style-type: none;

	}
	.article-listing__item {
		display: flex;
		padding: 1.2em 0;
		border-top: 1px solid #ccc;
		flex-direction: column;
		@include media-breakpoint-up(sm) {
			flex-direction: row;
		}
	}
	.article-listing__link {
		display: flex;
		flex-direction: column;
		@include media-breakpoint-up(sm) {
			flex-direction: row;
		}
	}

	.article-listing__thumbnail {
		margin: 0 0 1em 0;
		@include media-breakpoint-up(sm) {
			margin: 0 1em 0 0;
		}
	}
	.article-listing__thumbnail-img {
			width: 100%;
			max-width: auto;
			height: auto;
		@include media-breakpoint-up(sm) {
		 	width: auto;
		 	max-width: 238px;
		}
	}
	.title--article-listing {
		@include newsFont (#000, 20px, 500, 24px);
		margin-bottom: 1em;
	}
	.lang-warning {
		@include newsFont (#ccc, 14px, 500, 16px);
		display: block;
	}
	.article-listing__date {
		@include newsFont (#6e6e6e, 14px, 500, 16px);
		text-transform: uppercase;
		margin-bottom: 1em;
	}
	.article-listing__deck {
		@include newsFont (#6e6e6e, 16px, 400, 18px);
	}
	.side-panel {
		flex-basis: 30%;
		@include media-breakpoint-up(sm) {
			flex-basis: 30%;
		}
	}
	.side-panel__module {
		padding-bottom: 1em;
		margin-bottom: 1em;
		border-bottom: 1px solid #ccc;
		&:last-child {
			border-bottom: none;
		}
	}
	.title--side-panel {
		@include newsFont (#000, 18px, 500, 24px);
	}
	.title--video-side-panel {
		@include newsFont (#000, 16px, 500, 18px);
		margin-bottom: 5px;
	}
	.side-panel__text {
		@include newsFont (#000, 16px, 400, 26px);
	}
	.side-panel__text--sm {
		@include newsFont (#666, 13px, 400, 15px);
	}
	.side-panel__text--smb {
		@include newsFont (#666, 13px, 600, 15px);
	}
	.sidepanel__social-list {
		list-style-type: none;
		display: flex;
	}
	.sidepanel__social-list-item {
		margin-right: 10px;
	}
	.side-panel__module--video {
		display: flex;
	}
	.videobloc-link {
		display: flex;
	}
	.sidepanel__video-wrap {
		margin: 0;
		flex-basis: 35%;
	}
	.sidepanel__video-thumb {
		width: 100%;
		max-width: auto;
		height: auto;
	}
	.sidepanel__sidetext {
		flex-basis: 65%;
		padding-left: 15px;
	}
</style>
